type ChipColor = 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';

export function statusChipColor(status: string | null | undefined): ChipColor {
  const value = (status || '').trim().toUpperCase();
  switch (value) {
    case 'APPROVED':
      return 'success';
    case 'PENDING':
    case 'IN_APPEAL':
      return 'warning';
    case 'REJECTED':
    case 'DISABLED':
    case 'PAUSED':
    case 'DELETED':
    case 'FAILED':
    case 'LIMIT_EXCEEDED':
      return 'error';
    default:
      return 'default';
  }
}
